import React from "react";
import LoadingButton from "../../dumb/LoadingButton";
import { deleteTasks } from "../../../redux/ducks/task";
import useModal from "../../../hook/useModal";
import useStatusThunk from "../../../hook/useStatusThunk";
import DisplayError from "../../dumb/DisplayError";

const DeleteTask = props => {
    const [show, hide, renderModal] = useModal();

    const [d_deleteTasks, status, error, event] = useStatusThunk(deleteTasks);

    const deleteT = () => {
        if (props.selectedTasks.length > 0) {
            d_deleteTasks({ taskIDs: props.selectedTasks, projectID: props.projectID });
        }
    }

    event.onSuccess = () => hide();

    return (
        <React.Fragment>
            <button className={"button button--danger " + props.className} onClick={show}>Delete</button>
            {renderModal(
                <div className="delete-task">

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    <LoadingButton loading={status == "pending"} className={"button button--danger delete-task__delete-button"} onClick={() => deleteT()}>Delete</LoadingButton>
                </div>
            )}
        </React.Fragment>
    )
}

export default DeleteTask;